<template>
  <div class="fromStyle">
    <a-form :form="form" @submit="handleSubmit">
      <a-form-item
        label="岗位类型"
        :label-col="{ span: 5 }"
        :wrapper-col="{ span: 12 }"
      >
        <a-select
          v-decorator="[
            'role_type',
            { rules: [{ required: true, message: '请选择岗位类型!' }] }
          ]"
          placeholder="请选择岗位类型"
          @change="handleSelectChange"
        >
          <a-select-option
            v-for="(item, i) in typeList"
            :key="i"
            :value="item.value"
            >{{ item.label }}</a-select-option
          >
        </a-select>
      </a-form-item>
      <a-form-item
        label="岗位名称"
        :label-col="{ span: 5 }"
        :wrapper-col="{ span: 12 }"
      >
        <a-input
          v-decorator="[
            'role_name',
            { rules: [{ required: true, message: '请填写岗位名称!' }] }
          ]"
        />
      </a-form-item>
      <a-form-item :wrapper-col="{ span: 12, offset: 5 }">
        <a-button type="primary" html-type="submit">提交</a-button>
      </a-form-item>
    </a-form>
  </div>
</template>

<script>
import axios from "axios";
export default {
  inject: ["reload"],
  data() {
    return {
      typeList: [
        {
          label: "员工",
          value: 2
        },
        // {
        //   label: "内部员工",
        //   value: 1
        // },
        {
          label: "客户员工",
          value: 3
        }
      ],
      formLayout: "horizontal",
      form: this.$form.createForm(this)
    };
  },
  methods: {
    handleSubmit(e) {
      e.preventDefault();
      //   console.log(this.$store.state.token)
      this.form.validateFields((err, pramas) => {
        if (!err) {
          let url = this.httpsBasic.url + this.httpsBasic.user + "User/addRole";
          axios
            .post(url, {
              role_type: pramas.role_type,
              role_name: pramas.role_name,
              token: window.localStorage.getItem("xnwfPcToken")
            })
            .then(res => {
              if (res.data.code == 200) {
                this.$message.success("提交成功");
                this.$emit("hideInAdd", false);
                this.form.resetFields();
              } else {
                this.$message.warning(res.data.message);
              }
            })
            .catch(err => {
              this.$message.error("服务器出错了...");
            });
        }
      });
    },
    handleSelectChange(value) {
      //   console.log(value);
      //   this.form.setFieldsValue({
      //     note: `Hi, ${value === "male" ? "man" : "lady"}!`
      //   });
    }
  }
};
</script>

<style lang="less" scoped>
.fromStyle {
  margin: 12% 4%;
}
</style>
